//module của bảng Quy định lương, thuế, bảo hiểm
import api from '@/apis/di/pAOptionAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('PAOptions', api);

const state = {
  ...crud.state,
  _config: {
    table: 'pa_option',
    field: {
      key: 'pa_option_id',
      code: 'pa_option_code',
      name: 'option_value',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  //api lấy dữ liệu
  async getData(context, payload) {
    return await api.getDataPAOption(payload || {});
  },
  //api cập nhật dữ liệu
  async updateData(context, payload) {
    return await api.updateDataPAOption(payload || {});
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
